import { render, staticRenderFns } from "./ConfirmationModalButtons.vue?vue&type=template&id=66587cff&scoped=true&"
import script from "./ConfirmationModalButtons.vue?vue&type=script&lang=ts&"
export * from "./ConfirmationModalButtons.vue?vue&type=script&lang=ts&"
import style0 from "./ConfirmationModalButtons.vue?vue&type=style&index=0&id=66587cff&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66587cff",
  null
  
)

export default component.exports